import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import type { StickyLayoutProps } from '@/components/StickyLayout';
import { StickyLayout } from '@/components/StickyLayout';
import type {
  ContentfulFooterFragment,
  ContentfulMainHeaderFragment,
  ContentfulSearchOverlayFragment,
} from '@/graphql/contentful/api';
import { theme } from '@/theme/getTheme';

export type CMSLayoutDataProps = {
  footer?: ContentfulFooterFragment | null;
  header?: ContentfulMainHeaderFragment | null;
  search?: ContentfulSearchOverlayFragment | null;
};
export interface DefaultProps
  extends Pick<StickyLayoutProps, 'backgroundColor'> {
  children: React.ReactNode;
  cmsData?: CMSLayoutDataProps;
  draftMode?: boolean;
}

export const Default = ({
  backgroundColor,
  children,
  cmsData,
  draftMode,
}: DefaultProps) => {
  return (
    <StickyLayout backgroundColor={backgroundColor}>
      {cmsData?.header && (
        <Header
          data-test-id='DefaultHeader'
          draftMode={draftMode ?? false}
          {...(cmsData?.header as ContentfulMainHeaderFragment)}
          cmsSearchOverlayData={cmsData.search}
        />
      )}
      <StickyLayout.Main
        data-test-id='DefaultStickyLayoutMain'
        headerBackground={
          cmsData?.header?.background ??
          theme.components.header.defaultBackground
        }
      >
        {children}
      </StickyLayout.Main>
      {cmsData?.footer && (
        <Footer
          data-test-id='DefaultFooter'
          footerData={cmsData?.footer ?? {}}
        />
      )}
    </StickyLayout>
  );
};

Default.displayName = 'Default';
